module.exports = __webpack_public_path__ + "static/fonts/notokr-bold.073dba1.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/leader-seminar/font/notokr-bold.woff2
// module id = tL4V
// module chunks = 0